export const gridRowHeight = 40;
export const DEFAULT_TOOLTIP_DELAY = 1500;
